module.exports = __webpack_public_path__ + "img/bg_intro_train2.93eec9da.svg";